import { useEffect, useState } from 'react';
import { Alert, Button, Form, Modal } from 'react-bootstrap';
import { recordFailedAttempt } from '../api';

// shared_delivery_inter_business_billing.md item 14 - the delivery person records a failed
// delivery / customer unavailable: the waiting time and reason. For a shared-pool assignment this
// adds a failed-attempt + waiting charge to the inter-business settlement.
export default function FailedAttemptModal({ booking, show, onHide, onRecorded }) {
  const [waitingMinutes, setWaitingMinutes] = useState('10');
  const [reason, setReason] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!show) return;
    setWaitingMinutes('10');
    setReason('');
    setError('');
  }, [show]);

  if (!booking) return null;

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setError('');
    try {
      await recordFailedAttempt(booking._id, { reason: reason.trim(), waitingMinutes: Number(waitingMinutes) || 0 });
      onRecorded();
    } catch (err) {
      setError(err.response?.data?.msg || 'Unable to record the failed attempt.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Form onSubmit={submit}>
        <Modal.Header closeButton>
          <Modal.Title as="h5">Customer unavailable</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="small text-muted mb-2">
            Order #{booking._id.slice(-6).toUpperCase()} — records this failed attempt. The delivery
            is marked failed; the owner / admin can reassign or you can try again later.
          </p>
          {error && <Alert variant="danger" className="py-2">{error}</Alert>}
          <Form.Group className="mb-2" controlId="failed-waiting">
            <Form.Label>Waiting time (minutes)</Form.Label>
            <Form.Control type="number" min="0" max="600" required value={waitingMinutes} onChange={(e) => setWaitingMinutes(e.target.value)} />
          </Form.Group>
          <Form.Group controlId="failed-reason">
            <Form.Label>Reason</Form.Label>
            <Form.Control as="textarea" rows={2} maxLength={500} value={reason} onChange={(e) => setReason(e.target.value)} placeholder="e.g. nobody answered, phone switched off" />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="outline-secondary" onClick={onHide} disabled={submitting}>Cancel</Button>
          <Button variant="warning" type="submit" disabled={submitting}>{submitting ? 'Saving…' : 'Record failed attempt'}</Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
}
